module.exports = __webpack_public_path__ + "img/logo-boticario.aaad618e.png";